import React from "react";
import { useNavigate } from "react-router-dom";
import scooterLogo from "../../assets/Scooter1.png";

/**
 * Displays a session expiry message with option to return to login.
 * Automatically centers on screen with branded logo and clean styling.
 *
 * @returns {JSX.Element} Session expiration notification UI
*/

const SessionLogout = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="text-center">
        <img
          src={scooterLogo}
          alt="Scooter Logo"
          className="mx-auto mb-8"
          style={{ width: "150px" }}
        />
        <h1 className="font-semibold text-[25px] h-[31px] text-[#35424D] mb-4">
          Session Expired
        </h1>
        <p className="text-[#5D6871] h-[40px] text-[16px] font-medium mb-6">
        Your session has ended. Please log in<br></br> again to continue
        </p>
        <button
          onClick={handleLogin}
          className=" bg-[#1C40CA] text-white rounded w-[160px] h-[32px] items-center transition-colors"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default SessionLogout;
